// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1I_l2","containerItemsCenter":"Skeleton_containerItemsCenter__2XvFy"};